const { type } = require('constants/LuckySpot');

const initialState = {
   list: {
      loading: false,
      error: '',
      data: [],
      page: 1,
      totalPage: null,
      totalData: 0,
      params: '',
   },
   detail: {
      loading: false,
      error: '',
      data: null,
   },
   onCreate: {
      loading: false,
      error: '',
   },
   onUpdate: {
      loading: false,
      error: '',
   },
   onDelete: {
      loading: false,
      error: '',
   },
};

const luckySpotReducer = (state = initialState, action) => {
   switch (action.type) {
      case type.GET_LIST_LUCKY_SPOT_LOADING:
         return {
            ...state,
            list: {
               ...state.list,
               loading: true,
            },
         };
      case type.GET_LIST_LUCKY_SPOT_SUCCESS:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               error: '',
               data: action.data,
               totalPage: parseInt(action.totalPage),
               totalData: parseInt(action.totalData),
               page: action.page || state.list.page,
               params: action.params,
            },
         };
      case type.GET_LIST_LUCKY_SPOT_FAILED:
         return {
            ...state,
            list: {
               ...state.list,
               loading: false,
               error: action.message,
            },
         };
      case type.GET_DETAIL_LUCKY_SPOT_LOADING:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: true,
               error: '',
               data: null,
            },
         };
      case type.GET_DETAIL_LUCKY_SPOT_SUCCESS:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               error: '',
               data: action.data,
            },
         };
      case type.GET_DETAIL_LUCKY_SPOT_FAILED:
         return {
            ...state,
            detail: {
               ...state.detail,
               loading: false,
               error: action.message,
            },
         };
      case type.CREATE_LUCKY_SPOT_LOADING:
         return {
            ...state,
            onCreate: { loading: true, error: '' },
         };
      case type.CREATE_LUCKY_SPOT_SUCCESS:
         return {
            ...state,
            onCreate: { loading: false, error: '' },
         };
      case type.CREATE_LUCKY_SPOT_FAILED:
         return {
            ...state,
            onCreate: { loading: false, error: action.message },
         };
      case type.UPDATE_LUCKY_SPOT_LOADING:
         return {
            ...state,
            onUpdate: { loading: true, error: '' },
         };
      case type.UPDATE_LUCKY_SPOT_SUCCESS:
         return {
            ...state,
            onUpdate: { loading: false, error: '' },
         };
      case type.UPDATE_LUCKY_SPOT_FAILED:
         return {
            ...state,
            onUpdate: { loading: false, error: action.message },
         };
      case type.DELETE_LUCKY_SPOT_LOADING:
         return {
            ...state,
            onDelete: { loading: true, error: '' },
         };
      case type.DELETE_LUCKY_SPOT_SUCCESS:
         return {
            ...state,
            onDelete: { loading: false, error: '' },
         };
      case type.DELETE_LUCKY_SPOT_FAILED:
         return {
            ...state,
            onDelete: { loading: false, error: action.message },
         };
      default:
         return state;
   }
};

export default luckySpotReducer;
